// ================================================================
// PROPRIETARY & CONFIDENTIAL - Mt Forge Inc.
// Copyright (c) 2026 Mt Forge. All rights reserved.
// Unauthorized copying, reverse engineering, or AI-assisted
// reproduction of this software is strictly prohibited.
// Protected under US Copyright Law (17 U.S.C.) and international
// treaties. Patent Pending. License: PROPRIETARY
// ================================================================
import React, { useState } from "react";

const APP_PORTFOLIO = [
  { id: 1, brand: "CropPatrol", url: "croppatrol.pages.dev", vertical: "Agriculture", emoji: "\uD83C\uDF3E" },
  { id: 2, brand: "Forge Fleet", url: "haulsync.pages.dev", vertical: "Trucking & Logistics", emoji: "\uD83D\uDE9A" },
  { id: 3, brand: "Directional Ops", url: "directional-ops.pages.dev", vertical: "Oil & Gas Drilling", emoji: "\uD83D\uDEE2\uFE0F" },
  { id: 4, brand: "LotSync", url: "lotsync.pages.dev", vertical: "Used Cars & Transport", emoji: "\uD83D\uDE97" },
  { id: 5, brand: "NurseVault", url: "nursevault.pages.dev", vertical: "Healthcare (US)", emoji: "\uD83C\uDFE5" },
  { id: 6, brand: "NurseVault CA", url: "nursevault-ca.pages.dev", vertical: "Healthcare (Canada)", emoji: "\uD83C\uDDE8\uD83C\uDDE6" },
  { id: 7, brand: "Vantage Ops", url: "vantage-ops.pages.dev", vertical: "Field Service", emoji: "\uD83D\uDD27" },
  { id: 8, brand: "BudLedger", url: "budledger.pages.dev", vertical: "Cannabis Compliance", emoji: "\uD83C\uDF3F" },
  { id: 9, brand: "OreSync", url: "oresync.pages.dev", vertical: "Mining Operations", emoji: "\u26CF\uFE0F" },
  { id: 10, brand: "VacTraq", url: "vactraq.pages.dev", vertical: "Vacuum Truck Hauling", emoji: "\uD83D\uDE9B" },
  { id: 11, brand: "GlowDesk", url: "glowdesk.pages.dev", vertical: "Beauty & Salon", emoji: "\uD83D\uDC85" },
  { id: 12, brand: "ClosingDesk", url: "closingdesk.pages.dev", vertical: "Real Estate", emoji: "\uD83C\uDFE0" },
  { id: 13, brand: "WrenchSync", url: "wrenchsync.pages.dev", vertical: "Auto Repair", emoji: "\uD83D\uDD29" },
  { id: 14, brand: "TreadOps", url: "treadops.pages.dev", vertical: "Tire & Wheel", emoji: "\uD83D\uDEDE" },
  { id: 15, brand: "HerdLedger", url: "herdledger.pages.dev", vertical: "Cattle & Feedlot", emoji: "\uD83D\uDC04" },
  { id: 16, brand: "VitaSync", url: "vitasync.pages.dev", vertical: "Wellness & Holistic", emoji: "\uD83E\uDDD8" },
  { id: 17, brand: "PolicyForge", url: "policyforge.pages.dev", vertical: "Insurance Brokerage", emoji: "\uD83D\uDCCB" },
  { id: 18, brand: "StageVault", url: "stagevault.pages.dev", vertical: "Event Venues", emoji: "\uD83C\uDFAA" },
  { id: 19, brand: "MT Forge", url: "mt-forge-internal.pages.dev", vertical: "Internal Operations", emoji: "\u2699\uFE0F" },
  { id: 20, brand: "FormGenius", url: "formgenius.pages.dev", vertical: "Document Management", emoji: "\uD83D\uDCC4" },
  { id: 21, brand: "IOD", url: "islandoverheaddoors.pages.dev", vertical: "Overhead Doors & Multi-Trade", emoji: "\uD83D\uDEAA" },
  { id: 22, brand: "LiftForge", url: "hoist-control.pages.dev", vertical: "Hoist & Crane", emoji: "\uD83C\uDFD7\uFE0F" },
  { id: 23, brand: "RigForge", url: "rigwarden.pages.dev", vertical: "Rig Safety & Tool Push", emoji: "\uD83D\uDD29" },
  { id: 24, brand: "IronLedger", url: "ironledger.pages.dev", vertical: "Iron & Steel", emoji: "\u2692\uFE0F" },
  { id: 25, brand: "TowForge", url: "towforge.pages.dev", vertical: "Towing", emoji: "\uD83D\uDE9C" },
  { id: 26, brand: "FRCC", url: "filthy-redneck-cc.pages.dev", vertical: "Country Club", emoji: "\uD83C\uDFCC\uFE0F" },
  { id: 27, brand: "Forge Companion", url: "forge-companion.pages.dev", vertical: "AI Pet Care", emoji: "\uD83D\uDC3E" },
  { id: 28, brand: "FlorigenNFT", url: "florigen-nft.pages.dev", vertical: "Blockchain / NFT", emoji: "\uD83C\uDF38" },
  { id: 29, brand: "AisleSync", url: "aislesync.pages.dev", vertical: "Grocery", emoji: "\uD83D\uDED2" },
  { id: 30, brand: "PlateSync", url: "platesync.pages.dev", vertical: "Restaurant", emoji: "\uD83C\uDF7D\uFE0F" },
  { id: 31, brand: "CropPatrol (Broda WL)", url: "croppatrol-broda.pages.dev", vertical: "Agriculture (WL)", emoji: "\uD83C\uDF31" },
];

const MY_TASKS = [
  { id:1, title:"Review API documentation for v3", status:"in-progress", priority:"P1", project:"Platform", due:"Today" },
  { id:2, title:"Update deployment scripts", status:"todo", priority:"P0", project:"DevOps", due:"Today" },
  { id:3, title:"Code review: auth module refactor", status:"in-progress", priority:"P1", project:"Platform", due:"Tomorrow" },
  { id:4, title:"Write unit tests for billing", status:"todo", priority:"P2", project:"Billing", due:"Feb 12" },
  { id:5, title:"Prepare sprint demo slides", status:"todo", priority:"P2", project:"Team", due:"Feb 14" },
  { id:6, title:"Database migration plan", status:"review", priority:"P1", project:"Platform", due:"Yesterday" },
  { id:7, title:"Security audit follow-ups", status:"todo", priority:"P0", project:"Security", due:"Feb 10" },
  { id:8, title:"Client onboarding workflow", status:"in-progress", priority:"P1", project:"Product", due:"Feb 11" },
];

const MY_DEALS = [
  { id:1, name:"Canstorr Phase 2", value:"25,000", stage:"Proposal", nextStep:"Send revised SOW" },
  { id:2, name:"Mining Corp Integration", value:"5,000", stage:"Negotiation", nextStep:"Final pricing call" },
  { id:3, name:"Health Services Portal", value:"5,000", stage:"Qualified", nextStep:"Schedule demo" },
];

const MY_CALLS = [
  { id:1, contact:"Mike Thompson - Canstorr", time:"2:00 PM", purpose:"Contract follow-up" },
  { id:2, contact:"Sarah Chen - Western Mining", time:"3:30 PM", purpose:"Integration timeline" },
  { id:3, contact:"Dave Richards - Fleet Co", time:"Tomorrow 10 AM", purpose:"Onboarding check-in" },
];

const MY_FOLLOWUPS = [
  { id:1, contact:"Provincial Health Dept", due:"Today", context:"Awaiting compliance docs", status:"pending" },
  { id:2, contact:"Canstorr - Legal Team", due:"Tomorrow", context:"NDA signature pending", status:"pending" },
  { id:3, contact:"Mining Corp CFO", due:"Feb 10", context:"Budget approval update", status:"pending" },
  { id:4, contact:"Insurance Broker Lead", due:"Yesterday", context:"Demo feedback request", status:"overdue" },
];
const RECENT_ACTIVITY = [
  { id:1, text:"Completed: Update deployment scripts", time:"2 hrs ago" },
  { id:2, text:"Moved task to Review: Auth module refactor", time:"3 hrs ago" },
  { id:3, text:"Updated deal: Canstorr Phase 2 - sent proposal", time:"4 hrs ago" },
  { id:4, text:"Logged call: Mining Corp - 25 min", time:"5 hrs ago" },
  { id:5, text:"Added comment on: Security audit task", time:"Yesterday" },
  { id:6, text:"Created task: Client onboarding workflow", time:"Yesterday" },
];

/* --- Inline styles for the App Portfolio section --- */
const portfolioStyles = {
  section: {
    marginBottom: 32,
  },
  headerBar: {
    background: "linear-gradient(135deg, #0f2a1f 0%, #1e293b 100%)",
    border: "1px solid #10b981",
    borderRadius: 16,
    padding: "24px 28px",
    marginBottom: 20,
  },
  headerTop: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 16,
    marginBottom: 20,
  },
  headerTitle: {
    display: "flex",
    alignItems: "center",
    gap: 12,
  },
  headerIcon: {
    width: 44,
    height: 44,
    background: "linear-gradient(135deg, #10b981, #059669)",
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 20,
  },
  headerTextH2: {
    fontSize: 22,
    fontWeight: 800,
    color: "#f1f5f9",
    margin: 0,
  },
  headerTextP: {
    fontSize: 13,
    color: "#94a3b8",
    margin: 0,
    marginTop: 2,
  },
  platformBadge: {
    padding: "6px 14px",
    background: "#1e293b",
    border: "1px solid #334155",
    borderRadius: 8,
    fontSize: 12,
    color: "#94a3b8",
    fontWeight: 600,
    letterSpacing: 0.3,
  },
  statsRow: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: 12,
  },
  statBox: {
    background: "#0f172a",
    border: "1px solid #334155",
    borderRadius: 10,
    padding: "14px 16px",
    textAlign: "center",
  },
  statBoxValue: {
    fontSize: 22,
    fontWeight: 800,
    color: "#10b981",
  },
  statBoxLabel: {
    fontSize: 11,
    color: "#64748b",
    textTransform: "uppercase",
    letterSpacing: 0.5,
    fontWeight: 600,
    marginTop: 2,
  },
  searchBar: {
    marginBottom: 16,
    display: "flex",
    alignItems: "center",
    gap: 12,
  },
  searchInput: {
    flex: 1,
    maxWidth: 360,
    padding: "10px 14px",
    background: "#1e293b",
    border: "1px solid #334155",
    borderRadius: 8,
    color: "#e2e8f0",
    fontSize: 13,
    outline: "none",
  },
  appCount: {
    fontSize: 13,
    color: "#64748b",
    fontWeight: 600,
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
    gap: 14,
  },
  appCard: {
    background: "#1e293b",
    border: "1px solid #334155",
    borderRadius: 12,
    padding: "18px 20px",
    display: "flex",
    flexDirection: "column",
    gap: 12,
    transition: "all 0.2s ease",
    cursor: "default",
  },
  appCardTop: {
    display: "flex",
    alignItems: "center",
    gap: 12,
  },
  appEmoji: {
    width: 42,
    height: 42,
    background: "#0f172a",
    border: "1px solid #334155",
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 20,
    flexShrink: 0,
  },
  appInfo: {
    flex: 1,
    minWidth: 0,
  },
  appBrand: {
    fontSize: 15,
    fontWeight: 700,
    color: "#f1f5f9",
    margin: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  appVertical: {
    fontSize: 12,
    color: "#94a3b8",
    margin: 0,
    marginTop: 2,
  },
  appStatus: {
    display: "inline-flex",
    alignItems: "center",
    gap: 5,
    padding: "2px 8px",
    background: "#052e16",
    border: "1px solid #166534",
    borderRadius: 6,
    fontSize: 10,
    fontWeight: 700,
    color: "#4ade80",
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  statusDot: {
    width: 6,
    height: 6,
    background: "#4ade80",
    borderRadius: "50%",
  },
  appCardBottom: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderTop: "1px solid #334155",
    paddingTop: 12,
  },
  appUrl: {
    fontSize: 11,
    color: "#64748b",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "55%",
  },
  visitBtn: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    padding: "6px 14px",
    background: "linear-gradient(135deg, #10b981, #059669)",
    color: "white",
    border: "none",
    borderRadius: 6,
    fontSize: 12,
    fontWeight: 700,
    textDecoration: "none",
    cursor: "pointer",
    transition: "opacity 0.15s",
    whiteSpace: "nowrap",
  },
  appNumber: {
    position: "absolute",
    top: 8,
    right: 10,
    fontSize: 10,
    color: "#475569",
    fontWeight: 700,
  },
};

export default function DashboardPage() {
  const [taskFilter, setTaskFilter] = useState("all");
  const [appSearch, setAppSearch] = useState("");
  const overdue = MY_TASKS.filter(t => t.due === "Yesterday");
  const today = MY_TASKS.filter(t => t.due === "Today");
  const upcoming = MY_TASKS.filter(t => !["Today","Yesterday"].includes(t.due));

  const filteredApps = APP_PORTFOLIO.filter(app =>
    app.brand.toLowerCase().includes(appSearch.toLowerCase()) ||
    app.vertical.toLowerCase().includes(appSearch.toLowerCase()) ||
    app.url.toLowerCase().includes(appSearch.toLowerCase())
  );

  return (
    <div>
      <div className="page-header"><div><h1>My Dashboard</h1><p>Your personal command center</p></div></div>

      {/* ===== APP PORTFOLIO SECTION ===== */}
      <div style={portfolioStyles.section}>
        <div style={portfolioStyles.headerBar}>
          <div style={portfolioStyles.headerTop}>
            <div style={portfolioStyles.headerTitle}>
              <div style={portfolioStyles.headerIcon}>MT</div>
              <div>
                <h2 style={portfolioStyles.headerTextH2}>App Portfolio</h2>
                <p style={portfolioStyles.headerTextP}>Mt Forge - Complete Platform Suite</p>
              </div>
            </div>
            <div style={portfolioStyles.platformBadge}>React + Supabase + Cloudflare</div>
          </div>
          <div style={portfolioStyles.statsRow}>
            <div style={portfolioStyles.statBox}>
              <div style={portfolioStyles.statBoxValue}>{APP_PORTFOLIO.length}</div>
              <div style={portfolioStyles.statBoxLabel}>Total Apps</div>
            </div>
            <div style={portfolioStyles.statBox}>
              <div style={portfolioStyles.statBoxValue}>{new Set(APP_PORTFOLIO.map(a => a.vertical)).size}</div>
              <div style={portfolioStyles.statBoxLabel}>Verticals</div>
            </div>
            <div style={portfolioStyles.statBox}>
              <div style={{...portfolioStyles.statBoxValue, color: "#4ade80"}}>{APP_PORTFOLIO.length} / {APP_PORTFOLIO.length}</div>
              <div style={portfolioStyles.statBoxLabel}>Apps Live</div>
            </div>
            <div style={portfolioStyles.statBox}>
              <div style={{...portfolioStyles.statBoxValue, color: "#4ade80"}}>LIVE</div>
              <div style={portfolioStyles.statBoxLabel}>All Systems</div>
            </div>
          </div>
        </div>

        <div style={portfolioStyles.searchBar}>
          <input
            type="text"
            placeholder="Search apps by name, vertical, or URL..."
            value={appSearch}
            onChange={e => setAppSearch(e.target.value)}
            style={portfolioStyles.searchInput}
          />
          <span style={portfolioStyles.appCount}>
            Showing {filteredApps.length} of {APP_PORTFOLIO.length} apps
          </span>
        </div>

        <div style={portfolioStyles.grid}>
          {filteredApps.map(app => (
            <div key={app.id} style={{...portfolioStyles.appCard, position: "relative"}}
              onMouseEnter={e => { e.currentTarget.style.borderColor = "#10b981"; e.currentTarget.style.transform = "translateY(-2px)"; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = "#334155"; e.currentTarget.style.transform = "translateY(0)"; }}
            >
              <div style={portfolioStyles.appNumber}>#{app.id}</div>
              <div style={portfolioStyles.appCardTop}>
                <div style={portfolioStyles.appEmoji}>{app.emoji}</div>
                <div style={portfolioStyles.appInfo}>
                  <p style={portfolioStyles.appBrand}>{app.brand}</p>
                  <p style={portfolioStyles.appVertical}>{app.vertical}</p>
                </div>
                <div style={portfolioStyles.appStatus}>
                  <div style={portfolioStyles.statusDot}></div>
                  Live
                </div>
              </div>
              <div style={portfolioStyles.appCardBottom}>
                <span style={portfolioStyles.appUrl}>{app.url}</span>
                <a
                  href={"https://" + app.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={portfolioStyles.visitBtn}
                  onMouseEnter={e => { e.currentTarget.style.opacity = "0.85"; }}
                  onMouseLeave={e => { e.currentTarget.style.opacity = "1"; }}
                >
                  Visit App &rarr;
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* ===== END APP PORTFOLIO SECTION ===== */}

      <div className="stats-grid">
        <div className="stat-card"><div className="stat-label">My Open Tasks</div><div className="stat-value">{MY_TASKS.length}</div><div className="stat-change negative">{overdue.length} overdue</div></div>
        <div className="stat-card"><div className="stat-label">My Deals</div><div className="stat-value">{MY_DEALS.length}</div><div className="stat-change positive">75K total</div></div>
        <div className="stat-card"><div className="stat-label">Calls Today</div><div className="stat-value">{MY_CALLS.filter(c=>c.time.includes("PM")||c.time.includes("AM")).length}</div></div>
        <div className="stat-card"><div className="stat-label">Follow-Ups</div><div className="stat-value">{MY_FOLLOWUPS.length}</div><div className="stat-change negative">{MY_FOLLOWUPS.filter(f=>f.status==="overdue").length} overdue</div></div>
      </div>

      <div className="grid-2">
        <div className="card">
          <div className="card-header"><h3>My Tasks</h3>
            <select value={taskFilter} onChange={e=>setTaskFilter(e.target.value)} style={{padding:"4px 8px",background:"#0f172a",border:"1px solid #334155",borderRadius:6,color:"#e2e8f0",fontSize:12}}>
              <option value="all">All</option><option value="today">Today</option><option value="overdue">Overdue</option>
            </select>
          </div>
          {overdue.length > 0 && <div style={{marginBottom:12}}><div style={{fontSize:12,fontWeight:700,color:"#ef4444",marginBottom:6}}>OVERDUE</div>
            {overdue.map(t => (<div key={t.id} style={{display:"flex",justifyContent:"space-between",padding:"8px 0",borderBottom:"1px solid #334155"}}>
              <div><div style={{fontSize:13,fontWeight:600,color:"#e2e8f0"}}>{t.title}</div><div style={{fontSize:11,color:"#64748b"}}>{t.project}</div></div>
              <span className={"priority-tag priority-"+t.priority.toLowerCase()}>{t.priority}</span></div>))}
          </div>}
          {today.length > 0 && <div style={{marginBottom:12}}><div style={{fontSize:12,fontWeight:700,color:"#eab308",marginBottom:6}}>TODAY</div>
            {today.map(t => (<div key={t.id} style={{display:"flex",justifyContent:"space-between",padding:"8px 0",borderBottom:"1px solid #334155"}}>
              <div><div style={{fontSize:13,fontWeight:600,color:"#e2e8f0"}}>{t.title}</div><div style={{fontSize:11,color:"#64748b"}}>{t.project} - {t.status}</div></div>
              <span className={"priority-tag priority-"+t.priority.toLowerCase()}>{t.priority}</span></div>))}
          </div>}
          <div><div style={{fontSize:12,fontWeight:700,color:"#94a3b8",marginBottom:6}}>UPCOMING</div>
            {upcoming.map(t => (<div key={t.id} style={{display:"flex",justifyContent:"space-between",padding:"8px 0",borderBottom:"1px solid #334155"}}>
              <div><div style={{fontSize:13,fontWeight:600,color:"#e2e8f0"}}>{t.title}</div><div style={{fontSize:11,color:"#64748b"}}>{t.project} - Due: {t.due}</div></div>
              <span className={"priority-tag priority-"+t.priority.toLowerCase()}>{t.priority}</span></div>))}
          </div>
        </div>

        <div>
          <div className="card">
            <div className="card-header"><h3>My Deals</h3></div>
            {MY_DEALS.map(d => (<div key={d.id} style={{padding:"10px 0",borderBottom:"1px solid #334155"}}>
              <div style={{display:"flex",justifyContent:"space-between"}}>
                <span style={{fontSize:13,fontWeight:600,color:"#e2e8f0"}}>{d.name}</span>
                <span style={{fontSize:14,fontWeight:700,color:"#10b981"}}>{d.value}</span>
              </div>
              <div style={{display:"flex",justifyContent:"space-between",marginTop:4}}>
                <span style={{fontSize:11,color:"#64748b"}}>{d.stage}</span>
                <span style={{fontSize:11,color:"#94a3b8"}}>Next: {d.nextStep}</span>
              </div>
            </div>))}
          </div>

          <div className="card">
            <div className="card-header"><h3>Upcoming Calls</h3></div>
            {MY_CALLS.map(c => (<div key={c.id} style={{display:"flex",justifyContent:"space-between",padding:"10px 0",borderBottom:"1px solid #334155"}}>
              <div><div style={{fontSize:13,fontWeight:600,color:"#e2e8f0"}}>{c.contact}</div><div style={{fontSize:11,color:"#64748b"}}>{c.purpose}</div></div>
              <span style={{fontSize:12,color:"#10b981",fontWeight:600}}>{c.time}</span>
            </div>))}
          </div>

          <div className="card">
            <div className="card-header"><h3>Follow-Ups</h3></div>
            {MY_FOLLOWUPS.map(f => (<div key={f.id} style={{display:"flex",justifyContent:"space-between",padding:"10px 0",borderBottom:"1px solid #334155"}}>
              <div><div style={{fontSize:13,fontWeight:600,color:"#e2e8f0"}}>{f.contact}</div><div style={{fontSize:11,color:"#64748b"}}>{f.context}</div></div>
              <div style={{textAlign:"right"}}><div style={{fontSize:12,color:f.status==="overdue"?"#ef4444":"#94a3b8",fontWeight:600}}>{f.due}</div>
                <span className={"status-badge status-"+(f.status==="overdue"?"overdue":"pending")} style={{fontSize:10}}>{f.status}</span></div>
            </div>))}
          </div>
        </div>
      </div>

      <div className="card" style={{marginTop:16}}>
        <div className="card-header"><h3>Recent Activity</h3></div>
        <div className="activity-feed">
          {RECENT_ACTIVITY.map(a => (
            <div key={a.id} className="activity-item">
              <div className="activity-content">
                <div className="activity-text">{a.text}</div>
                <div className="activity-time">{a.time}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="grid-3" style={{marginTop:16}}>
        <div className="stat-card" style={{textAlign:"center"}}><div className="stat-label">Tasks Completed This Week</div><div className="stat-value" style={{color:"#10b981"}}>12</div></div>
        <div className="stat-card" style={{textAlign:"center"}}><div className="stat-label">Hours Logged</div><div className="stat-value">36.5</div></div>
        <div className="stat-card" style={{textAlign:"center"}}><div className="stat-label">On-Time Rate</div><div className="stat-value" style={{color:"#10b981"}}>94%</div></div>
      </div>

      <div className="card" style={{marginTop:16}}>
        <div className="card-header"><h3>Quick Actions</h3></div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12}}>
          <button className="btn btn-primary" style={{padding:16,textAlign:"center"}}>New Task</button>
          <button className="btn btn-secondary" style={{padding:16,textAlign:"center"}}>Log Call</button>
          <button className="btn btn-secondary" style={{padding:16,textAlign:"center"}}>New Deal</button>
          <button className="btn btn-secondary" style={{padding:16,textAlign:"center"}}>Log Visit</button>
        </div>
      </div>

      <div className="card" style={{marginTop:16}}>
        <div className="card-header"><h3>My Calendar - This Week</h3></div>
        {["Mon","Tue","Wed","Thu","Fri"].map((day,i) => (
          <div key={day} style={{display:"flex",alignItems:"center",gap:16,padding:"10px 0",borderBottom:"1px solid #334155"}}>
            <div style={{width:60,fontSize:13,fontWeight:700,color:i===0?"#10b981":"#94a3b8"}}>{day} {8+i}</div>
            <div style={{flex:1}}>
              {i===0 && <div style={{fontSize:12,color:"#e2e8f0",padding:"4px 8px",background:"#334155",borderRadius:4,marginBottom:4}}>10:00 - Board Strategy Session</div>}
              {i===0 && <div style={{fontSize:12,color:"#e2e8f0",padding:"4px 8px",background:"#0f2a1f",borderRadius:4,borderLeft:"2px solid #10b981"}}>1:00 - Client Review: Canstorr</div>}
              {i===1 && <div style={{fontSize:12,color:"#e2e8f0",padding:"4px 8px",background:"#334155",borderRadius:4}}>2:00 - Sprint Planning</div>}
              {i===2 && <div style={{fontSize:12,color:"#e2e8f0",padding:"4px 8px",background:"#334155",borderRadius:4}}>11:00 - Team Standup</div>}
              {i===3 && <div style={{fontSize:12,color:"#e2e8f0",padding:"4px 8px",background:"#0f2a1f",borderRadius:4,borderLeft:"2px solid #10b981"}}>3:00 - Western Mining Demo</div>}
              {i===4 && <div style={{fontSize:12,color:"#94a3b8"}}>No meetings</div>}
            </div>
          </div>
        ))}
      </div>

      <div className="grid-2" style={{marginTop:16}}>
        <div className="card">
          <div className="card-header"><h3>Productivity Trend</h3></div>
          <div className="chart-bar-container">
            {["Week 1","Week 2","Week 3","This Week"].map((wk,i) => (
              <div key={wk} className="chart-bar-row">
                <span className="chart-bar-label">{wk}</span>
                <div className="chart-bar-track"><div className={"chart-bar-fill"+(i===3?"":" blue")} style={{width:[65,72,68,85][i]+"%"}}>{[8,11,9,12][i]} tasks</div></div>
              </div>
            ))}
          </div>
        </div>
        <div className="card">
          <div className="card-header"><h3>Priorities Breakdown</h3></div>
          {[{label:"P0 - Critical",count:2,color:"#ef4444"},{label:"P1 - High",count:3,color:"#f97316"},{label:"P2 - Medium",count:2,color:"#eab308"},{label:"P3 - Low",count:1,color:"#64748b"}].map(p => (
            <div key={p.label} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 0",borderBottom:"1px solid #334155"}}>
              <span style={{fontSize:13,color:"#e2e8f0"}}>{p.label}</span>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <div style={{width:60,height:6,background:"#334155",borderRadius:3}}><div style={{width:(p.count/3*100)+"%",height:6,background:p.color,borderRadius:3}}/></div>
                <span style={{fontSize:13,fontWeight:700,color:p.color}}>{p.count}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
